import { Fragment } from "react";

import { Element } from "@craftjs/core";

import { prop, define } from "@/components/builder/utils";
import { DnDBypassProvider } from "@/components/builder/utils/bypass-context";

import { FormButtonGridBlock } from "../../..";
import BasePreview from "../../../base";
import { useFormFieldContext } from "../context";

const BOOLEAN_OPTIONS = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
]

function FormButtonsGridPreview({ ...props }) {
  const { field: { field_options, gridCols } } = useFormFieldContext()

  return <BasePreview {...props}>
    <div className={`grid-cols-${gridCols}`}>
      {(field_options || BOOLEAN_OPTIONS).map(({ label, value }) => <DnDBypassProvider key={`${value}-button-provider`} data={{ label, value }}>
        <Element key={`${value}-button`} is={FormButtonGridBlock} id={`${value}-button`} />
      </DnDBypassProvider>)}
    </div>
  </BasePreview>
}

export default define('form-buttons-grid-container', FormButtonsGridPreview, Fragment)
  .shared(prop.share('FormButtonsGridContainer', 'form-buttons-grid-container'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.layout())
  .hideProps(['grid.rows.columns', 'layoutType', 'grid.width', 'grid.height'])
  .defaultProps({
    layoutType: 'grid',
  })
  .build()

